module.exports = __webpack_public_path__ + "static/media/m11tj0.228dd7c4.png";